import {
  getRejectReasonTypes,
  RejectReasonTypesResponse,
  SuccessResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* rejectReasonTypesRequest(
  self: Self
): Generator<Promise<FlowReturn<RejectReasonTypesResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getRejectReasonTypes();
    const { data, status } = (response as RejectReasonTypesResponse).data;
    if (status.code === 1000) {
      self.rejectReasonTypes.reset();
      self.rejectReasonTypes.list = cast(data);
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default rejectReasonTypesRequest;
